import React, { Component } from "react";
import styled from "react-emotion";

// import NotFoundPage from '../NotFoundPage';
import MaxWidth from "../Layout/MaxWidth";
import elementList from "../ContentManager/elementList";
import { ContentRenderer } from "../ContentManager/CustomContentRenderer";

const Header = styled("h1")`
  text-align: center;
  padding: 1rem;
  text-transform: uppercase;
  font-size: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const Content = styled("div")`
  padding-bottom: 1rem;
  max-width: 800px;
  margin: auto;
  line-height: 1.3;
  font-family: "Open Sans", sans-serif;
  width: 100%;

  a {
    color: black;
    text-decoration: underline;
  }
`;

class ContentPage extends Component {
  render() {
    const {
      result: { data },
    } = this.props;

    const page = data?.route?.object;

    return page ? (
      <div>
        <MaxWidth>
          {/* <Header>{page?.mainHeader || page?.name}</Header> */}

          {page?.data?.items?.length > 0 ? (
            <ContentRenderer items={page.data.items} components={elementList} />
          ) : (
            <Content dangerouslySetInnerHTML={{ __html: page?.content }} />
          )}
        </MaxWidth>
      </div>
    ) : null;
  }
}

export default ContentPage;
